class Logger {
  static async logInteraction(userInput, aiResponse, movieResults) {
    try {
      // Create log entry
      const logEntry = {
        timestamp: new Date().toISOString(),
        userInput: userInput,
        aiResponse: aiResponse,
        numberOfMoviesRecommended: movieResults ? movieResults.length : 0,
        movieTitles: movieResults ? movieResults.map(m => m.title) : [],
        conversationId: this.getCurrentConversationId()
      };

      // Log to console for development
      console.log('Interaction Log:', logEntry);

      // Store in localStorage
      this.storeInLocalStorage(logEntry);
    } catch (error) {
      console.error('Logging failed:', error);
    }
  }

  static getCurrentConversationId() {
    let id = localStorage.getItem('currentConversationId');
    if (!id) {
      id = new Date().getTime().toString();
      localStorage.setItem('currentConversationId', id);
    }
    return id;
  }

  static resetConversation() {
    localStorage.removeItem('currentConversationId');
  }

  static storeInLocalStorage(logEntry) {
    try {
      // Get existing logs
      const logs = JSON.parse(localStorage.getItem('movieRecommenderLogs') || '[]');
      
      // Add new log
      logs.push(logEntry);
      
      // Keep only last 100 conversations to prevent storage issues
      while (logs.length > 100) {
        logs.shift();
      }
      
      // Save back to localStorage
      localStorage.setItem('movieRecommenderLogs', JSON.stringify(logs));
    } catch (error) {
      console.error('Failed to store log in localStorage:', error);
    }
  }

  static getLogs() {
    try {
      return JSON.parse(localStorage.getItem('movieRecommenderLogs') || '[]');
    } catch (error) {
      console.error('Failed to retrieve logs:', error);
      return [];
    }
  }

  static getConversation(conversationId) {
    const logs = this.getLogs();
    return logs.filter(log => log.conversationId === conversationId);
  }

  static clearLogs() {
    localStorage.removeItem('movieRecommenderLogs');
    localStorage.removeItem('currentConversationId');
  }
}

export default Logger;
